export default __webpack_public_path__ + "static/media/3.c477c0a2.png";